var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 471",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#0079BE",
    width: 750,
    height: 471,
    rx: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 238c0-99-83-168-174-168h-78a167 167 0 100 333h78c91 1 174-74 174-165z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 84a152 152 0 101 305 152 152 0 00-1-305z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237 236c0-41 26-76 62-90v180a97 97 0 01-62-90zm131 90V146a97 97 0 010 180z",
    fill: "#FFF"
  }))));
}
export default SvgDiners;